import { BaseAsset } from "../../base";
import { ExternalAssetSource } from "../../../types";

export function deriveVideoName(pageURL: string): string {
  const id = pageURL.substring(0, pageURL.length - 1).split('/').pop()?.split('-').pop() ?? '';
  return `Pexels Video ${id}`;
}

/**
 * Abstract base for all Pexels assets.
 * Concrete subclasses handle images and videos separately.
 */
export abstract class BasePexelsAsset extends BaseAsset {
  protected id: number;
  protected url: string;

  constructor(id: number, url: string) {
    super();
    this.id = id;
    this.url = url;
  }

  getId(): string {
    return this.id.toString();
  }

  setName(_name: string): void {
    console.warn('Pexels assets cannot be renamed');
  }

  getWorkspaceId(): string | undefined {
    return undefined;
  }

  getSource(): string {
    return ExternalAssetSource.Pexels;
  }

  downloadFileVersion(_versionId: string): Promise<{ blob: Blob; filename: string }> {
    return Promise.reject(new Error('Versioning not supported'));
  }
}
